module.exports = {
	"elementSelector": "[data-riot-mount=\"ddjnrw-app\"]",
	"containerClass": "measurement-viz__container",
	"infobox": {
		"cssClass": "measurement-viz__infobox",
		"width": 300,
		"position": {
			"top": 10,
			"left": 10
		}
	},
	"mainChart": {
		"width": 700,
		"itemHeight": 25,
		"nItems": 25,
		"margin": {
			"top": 20,
			"right": 20,
			"bottom": 20,
			"left": 120
		}
	},
	"breakpoints": {
		"small": 600,
		"medium": 768,
		"large": 1280
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./src/config.json
// module id = 41
// module chunks = 0